import { useTracing } from '@hooks'
import { getSiteLanguage } from '@utils'
import useSWR from 'swr'

const getParametersForRequest =
  (artworkId, artistId, onlineShowId, limit, fingerprint, agentKey, showRecommendationAlgorithms) => {
    const isMlLogic = showRecommendationAlgorithms === 'REC_ENG_ALG'
    const orderBy = `${isMlLogic ? 'rscore' : 'atscore'}(${artworkId}:${agentKey}::${fingerprint}) DESC`
    const locale = getSiteLanguage()
    const parameters = {
      onlineShowId,
      limit,
      excludeIds: artworkId,
      orderBy: orderBy,
      includeEventArtworks: 'true',
      includeArtworksNotInShows: 'true',
      includeOnlySpecialRoomArtworks: false,
      specialRoom: false,
      offset: 0,
      fields: 'galleryId,cleanTitle,id,fromPrice,priceInUsd,toPrice,artistName,displayName,year,galleryName,visiblePrice,visibilityStatus,' +
        'images,imageUrl,sponsorGalleries,sold,sponsorArtists,inquiryEnabled,curator,reservedArtwork,viewAtFair',
      locale
    }
    // this part is done because for ML Logic we dont have to send artist id
    if (!isMlLogic) {
      parameters['artistId'] = artistId
    }

    return Object.keys(parameters)
      .map((key) => `${key}=${parameters[key]}`)
      .join('&')
  }

/**
 * Fetches the recommended artworks for an artwork in a page inside OVR show
 * artistId can be multiple (1,2,3,4)
 */
function useGetArtworksRecommendations(artworkId, artistId, onlineShowId, showRecommendationAlgorithms, limit = 6) {
  const { fingerprint, agentKey } = useTracing()
  const hasToFetch = !!(artworkId && onlineShowId && limit && artistId && fingerprint && agentKey)
  const { data, isValidating, error } = useSWR(
    hasToFetch
      ? `/msvc/v1/artcatalog/artwork/itemDetails?${getParametersForRequest(
        artworkId,
        artistId,
        onlineShowId,
        limit,
        fingerprint,
        agentKey,
        showRecommendationAlgorithms
      )}`
      : null
  )

  return {
    data,
    isLoading: isValidating || typeof data === 'undefined',
    error
  }
}

export default useGetArtworksRecommendations
